import localizationKeys from "../../i18n/localizationKeys";

export const ADDITIONAL_ELECTRIC_TREND_TYPE = {
  SEP_ELECTRIC_POWER: "sep_electric_power",
  DGCURRENT: "dgcurrent",
  BUSVOLT: "busvolt",
  MAINDGMACHINERY: "dgmachinery",
  GECYLTEMP1: "gecyltemp1",
  GECYLTEMP2: "gecyltemp2",
  GECYLTEMP3: "gecyltemp3",
  GECYLTEMP4: "gecyltemp4",
  GECYLTEMP5: "gecyltemp5",
};

export const ADDITIONAL_ELECTRIC_TREND_LIST = [
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    title: localizationKeys.ElectricTrendGraph_upper,
    commonNames: [
      "/jsmea_mac/DieselGeneratorSet/Generator1/Electric//Power/",
      "/jsmea_mac/DieselGeneratorSet/Generator2/Electric//Power/",
      "/jsmea_mac/DieselGeneratorSet/Generator3/Electric//Power/",
      "/jsmea_mac/DieselGeneratorSet/Generator4/Electric//Power/",
      "/jsmea_mac/DieselGeneratorSet/Generator5/Electric//Power/",
      "/jsmea_mac/ShaftGeneratorMotorSystem/Generator1/Electric//Power/",
      "/jsmea_mac/ShaftGeneratorMotorSystem/Generator2/Electric//Power/",
      "/jsmea_mac/ShaftGeneratorMotorSystem/Generator3/Electric//Power/",
      "/jsmea_mac/ShaftGeneratorMotorSystem/Generator4/Electric//Power/",
      "/jsmea_mac/ShaftGeneratorMotorSystem/Generator5/Electric//Power/",
      "/jrcs_mac/DieselGeneratorSet/Generator1//Reactive/Power/",
      "/jrcs_mac/DieselGeneratorSet/Generator2//Reactive/Power/",
      "/jrcs_mac/DieselGeneratorSet/Generator3//Reactive/Power/",
      "/jrcs_mac/DieselGeneratorSet/Generator4//Reactive/Power/",
      "/jrcs_mac/DieselGeneratorSet/Generator5//Reactive/Power/",
    ]
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.DGCURRENT,
    title: localizationKeys.DGCurrent,
    commonNames: [
      "/jsmea_mac/DieselGeneratorSet/Generator1/Electric//Current/",
	    "/jsmea_mac/DieselGeneratorSet/Generator2/Electric//Current/",
	    "/jsmea_mac/DieselGeneratorSet/Generator3/Electric//Current/",
      "/jsmea_mac/DieselGeneratorSet/Generator4/Electric//Current/",
	    "/jsmea_mac/DieselGeneratorSet/Generator5/Electric//Current/",
    ]
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
    title: localizationKeys.BusVoltCurrent,
    commonNames: [
      "/jrcs_mac/PowerElectricSystem/LowVoltageMainSwitchboardA/AC440VBus//Voltage/",
      "/jrcs_mac/PowerElectricSystem/LowVoltageMainSwitchboardB/AC440VBus//Voltage/",
      "/jrcs_mac/PowerElectricSystem/LowVoltageMainSwitchboardC/AC440VBus//Voltage/",
      "/jsmea_mac/PowerElectricSystem/LowVoltageMainSwitchboardA/AC440VBus//Voltage/",
      "/jsmea_mac/PowerElectricSystem/LowVoltageMainSwitchboardB/AC440VBus//Voltage/",
      "/jsmea_mac/PowerElectricSystem/LowVoltageSwitchboard1/AC440VBus//Current/",
      "/jsmea_mac/PowerElectricSystem/LowVoltageSwitchboard2/AC440VBus//Current/",
      "/jrcs_mac/PowerElectricSystem/ShorePower///Current/"
    ]
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
    title: localizationKeys.MainDGMachineryStatus,
    commonNames: [
      "/jsmea_mac/DieselGeneratorSet/Engine1/LubOil/Inlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Engine2/LubOil/Inlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Engine3/LubOil/Inlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Engine4/LubOil/Inlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Engine5/LubOil/Inlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/CoolingFreshWater/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/CoolingFreshWater/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/CoolingFreshWater/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/CoolingFreshWater/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/CoolingFreshWater/Outlet/Temp/",
      "/jrcs_mac/DieselGeneratorSet/Engine1/ExhaustGas/Outlet/Temp/",
      "/jrcs_mac/DieselGeneratorSet/Engine2/ExhaustGas/Outlet/Temp/",
      "/jrcs_mac/DieselGeneratorSet/Engine3/ExhaustGas/Outlet/Temp/",
      "/jrcs_mac/DieselGeneratorSet/Engine4/ExhaustGas/Outlet/Temp/",
      "/jrcs_mac/DieselGeneratorSet/Engine5/ExhaustGas/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Engine1/LubOil/Inlet/Press/",
      "/jsmea_mac/DieselGeneratorSet/Engine2/LubOil/Inlet/Press/",
      "/jsmea_mac/DieselGeneratorSet/Engine3/LubOil/Inlet/Press/",
      "/jsmea_mac/DieselGeneratorSet/Engine4/LubOil/Inlet/Press/",
      "/jsmea_mac/DieselGeneratorSet/Engine5/LubOil/Inlet/Press/",
      "/jrcs_mac/DieselGeneratorSet/GeneratorBearing1/LubOil//Press/",
      "/jrcs_mac/DieselGeneratorSet/GeneratorBearing2/LubOil//Press/",
      "/jrcs_mac/DieselGeneratorSet/GeneratorBearing3/LubOil//Press/",
      "/jrcs_mac/DieselGeneratorSet/GeneratorBearing4/LubOil//Press/",
      "/jrcs_mac/DieselGeneratorSet/GeneratorBearing5/LubOil//Press/",
    ]
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
    title: localizationKeys.No1GECylTemp,
    commonNames: [
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas1/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas2/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas3/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas4/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas5/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas6/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas7/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas8/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas9/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas10/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas11/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas12/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas13/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas14/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas15/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas16/Outlet/Temp/",
    ]
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
    title: localizationKeys.No2GECylTemp,
    commonNames: [
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas1/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas2/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas3/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas4/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas5/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas6/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas7/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas8/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas9/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas10/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas11/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas12/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas13/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas14/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas15/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas16/Outlet/Temp/",
    ]
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
    title: localizationKeys.No3GECylTemp,
    commonNames: [
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas1/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas2/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas3/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas4/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas5/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas6/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas7/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas8/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas9/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas10/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas11/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas12/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas13/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas14/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas15/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas16/Outlet/Temp/",
    ]
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
    title: localizationKeys.No4GECylTemp,
    commonNames: [
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas1/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas2/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas3/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas4/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas5/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas6/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas7/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas8/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas9/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas10/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas11/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas12/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas13/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas14/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas15/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas16/Outlet/Temp/",
    ]
  },
  {
    id: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
    title: localizationKeys.No5GECylTemp,
    commonNames: [
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas1/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas2/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas3/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas4/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas5/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas6/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas7/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas8/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas9/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas10/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas11/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas12/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas13/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas14/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas15/Outlet/Temp/",
      "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas16/Outlet/Temp/",
    ]
  },
];

export const additionalElectricTrendLines = [
  //for ELECTRIC POWER
    {
      key: "/jsmea_mac/DieselGeneratorSet/Generator1/Electric//Power/",
      keyName: "/jsmea_mac/DieselGeneratorSet/Generator1/Electric//Power/",
      name: "1 D/G",
      color: "#66c0f6",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jsmea_mac/DieselGeneratorSet/Generator2/Electric//Power/",
      keyName: "/jsmea_mac/DieselGeneratorSet/Generator2/Electric//Power/",
      name: "2 D/G",
      color: "#84eeff",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jsmea_mac/DieselGeneratorSet/Generator3/Electric//Power/",
      keyName: "/jsmea_mac/DieselGeneratorSet/Generator3/Electric//Power/",
      name: "3 D/G",
      color: "#56ebc1",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jsmea_mac/DieselGeneratorSet/Generator4/Electric//Power/",
      keyName: "/jsmea_mac/DieselGeneratorSet/Generator4/Electric//Power/",
      name: "4 D/G",
      color: "#56eb92",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jsmea_mac/DieselGeneratorSet/Generator5/Electric//Power/",
      keyName: "/jsmea_mac/DieselGeneratorSet/Generator5/Electric//Power/",
      name: "5 D/G",
      color: "#56eb6a",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jsmea_mac/ShaftGeneratorMotorSystem/Generator1/Electric//Power/",
      keyName: "/jsmea_mac/ShaftGeneratorMotorSystem/Generator1/Electric//Power/",
      name: "1 S/G",
      color: "#b4affb",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jsmea_mac/ShaftGeneratorMotorSystem/Generator2/Electric//Power/",
      keyName: "/jsmea_mac/ShaftGeneratorMotorSystem/Generator2/Electric//Power/",
      name: "2 S/G",
      color: "#8f81ff",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jsmea_mac/ShaftGeneratorMotorSystem/Generator3/Electric//Power/",
      keyName: "/jsmea_mac/ShaftGeneratorMotorSystem/Generator3/Electric//Power/",
      name: "3 S/G",
      color: "#ffffff",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jsmea_mac/ShaftGeneratorMotorSystem/Generator4/Electric//Power/",
      keyName: "/jsmea_mac/ShaftGeneratorMotorSystem/Generator4/Electric//Power/",
      name: "4 S/G",
      color: "#ffffff",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jsmea_mac/ShaftGeneratorMotorSystem/Generator5/Electric//Power/",
      keyName: "/jsmea_mac/ShaftGeneratorMotorSystem/Generator5/Electric//Power/",
      name: "5 S/G",
      color: "#ffffff",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jrcs_mac/DieselGeneratorSet/Generator1//Reactive/Power/",
      keyName: "/jrcs_mac/DieselGeneratorSet/Generator1//Reactive/Power/",
      name: "NO.1 D/G REACTIVE POWER",
      color: "#66c0f6",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jrcs_mac/DieselGeneratorSet/Generator2//Reactive/Power/",
      keyName: "/jrcs_mac/DieselGeneratorSet/Generator2//Reactive/Power/",
      name: "NO.2 D/G REACTIVE POWER",
      color: "#84eeff",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jrcs_mac/DieselGeneratorSet/Generator3//Reactive/Power/",
      keyName: "/jrcs_mac/DieselGeneratorSet/Generator3//Reactive/Power/",
      name: "NO.3 D/G REACTIVE POWER",
      color: "#56ebc1",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jrcs_mac/DieselGeneratorSet/Generator4//Reactive/Power/",
      keyName: "/jrcs_mac/DieselGeneratorSet/Generator4//Reactive/Power/",
      name: "NO.4 D/G REACTIVE POWER",
      color: "#56eb92",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
    {
      key: "/jrcs_mac/DieselGeneratorSet/Generator5//Reactive/Power/",
      keyName: "/jrcs_mac/DieselGeneratorSet/Generator5//Reactive/Power/",
      name: "NO.5 D/G REACTIVE POWER",
      color: "#56eb6a",
      enableVisibilityIcon: "hidden",
      enable: true,
      chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.SEP_ELECTRIC_POWER,
    },
  //for DGCurrent
  {
    key: "/jsmea_mac/DieselGeneratorSet/Generator1/Electric//Current/",
    name: "NO.1 D/G CURRENT",
    keyName: "/jsmea_mac/DieselGeneratorSet/Generator1/Electric//Current/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.DGCURRENT,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Generator2/Electric//Current/",
    name: "NO.2 D/G CURRENT",
    keyName: "/jsmea_mac/DieselGeneratorSet/Generator2/Electric//Current/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.DGCURRENT,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Generator3/Electric//Current/",
    name: "NO.3 D/G CURRENT",
    keyName: "/jsmea_mac/DieselGeneratorSet/Generator3/Electric//Current/",
    color: "#a29bfe",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.DGCURRENT,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Generator4/Electric//Current/",
    name: "NO.4 D/G CURRENT",
    keyName: "/jsmea_mac/DieselGeneratorSet/Generator4/Electric//Current/",
    color: "#6c5de7",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.DGCURRENT,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Generator5/Electric//Current/",
    name: "NO.5 D/G CURRENT",
    keyName: "/jsmea_mac/DieselGeneratorSet/Generator5/Electric//Current/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.DGCURRENT,
  },
  // // for BusVolt
  {
    key: "/jrcs_mac/PowerElectricSystem/LowVoltageMainSwitchboardA/AC440VBus//Voltage/",
    name: "MSB A BUS VOLTAGE",
    keyName: "/jrcs_mac/PowerElectricSystem/LowVoltageMainSwitchboardA/AC440VBus//Voltage/",
    color: "#57cee1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
  },
  {
    key: "/jrcs_mac/PowerElectricSystem/LowVoltageMainSwitchboardB/AC440VBus//Voltage/",
    name: "MSB B BUS VOLTAGE",
    keyName: "/jrcs_mac/PowerElectricSystem/LowVoltageMainSwitchboardB/AC440VBus//Voltage/",
    color: "#56ebc1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
  },
  {
    key: "/jrcs_mac/PowerElectricSystem/LowVoltageMainSwitchboardC/AC440VBus//Voltage/",
    name: "MSB C BUS VOLTAGE",
    keyName: "/jrcs_mac/PowerElectricSystem/LowVoltageMainSwitchboardC/AC440VBus//Voltage/",
    color: "#911eb4",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
  },
  {
    key:  "/jsmea_mac/PowerElectricSystem/LowVoltageMainSwitchboardA/AC440VBus//Voltage/",
    name: "440V A BUS VOLTAGE",
    keyName:  "/jsmea_mac/PowerElectricSystem/LowVoltageMainSwitchboardA/AC440VBus//Voltage/",
    color: "#e6beff",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
  },
  {
    key: "/jsmea_mac/PowerElectricSystem/LowVoltageMainSwitchboardB/AC440VBus//Voltage/",
    name: "440V B BUS VOLTAGE",
    keyName: "/jsmea_mac/PowerElectricSystem/LowVoltageMainSwitchboardB/AC440VBus//Voltage/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
  },
  {
    key: "/jsmea_mac/PowerElectricSystem/LowVoltageSwitchboard1/AC440VBus//Current/",
    name: "MSB NO.1 440V BUS CURRENT",
    keyName: "/jsmea_mac/PowerElectricSystem/LowVoltageSwitchboard1/AC440VBus//Current/",
    color: "#f553ec",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
  },
  {
    key: "/jsmea_mac/PowerElectricSystem/LowVoltageSwitchboard2/AC440VBus//Current/",
    name: "MSB NO.2 440V BUS CURRENT",
    keyName: "/jsmea_mac/PowerElectricSystem/LowVoltageSwitchboard2/AC440VBus//Current/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
  },
  {
    key: "/jrcs_mac/PowerElectricSystem/ShorePower///Current/",
    name: "SHARE POWER CURRENT",
    keyName: "/jrcs_mac/PowerElectricSystem/ShorePower///Current/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.BUSVOLT,
  },
  // Main DG Machinery
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Engine1/LubOil/Inlet/Temp/",
    name: "NO.1 G/E LO ENG IN TEMP",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Engine1/LubOil/Inlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Engine2/LubOil/Inlet/Temp/",
    name: "NO.2 G/E LO ENG IN TEMP",
    keyName: "/jsmea_mac/DieselGeneratorSet/Engine2/LubOil/Inlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Engine3/LubOil/Inlet/Temp/",
    name: "NO.3 G/E LO ENG IN TEMP",
    keyName: "/jsmea_mac/DieselGeneratorSet/Engine3/LubOil/Inlet/Temp/",
    color: "#a29bfe",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Engine4/LubOil/Inlet/Temp/",
    name: "NO.4 G/E LO ENG IN TEMP",
    keyName: "/jsmea_mac/DieselGeneratorSet/Engine4/LubOil/Inlet/Temp/",
    color: "#6c5de7",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Engine5/LubOil/Inlet/Temp/",
    name: "NO.5 G/E LO ENG IN TEMP",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Engine5/LubOil/Inlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder1/CoolingFreshWater/Outlet/Temp/",
    name: "NO.1 G/E HT CFW ENG OUT TEMP",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder1/CoolingFreshWater/Outlet/Temp/",
    color: "#57cee1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder2/CoolingFreshWater/Outlet/Temp/",
    name: "NO.2 G/E HT CFW ENG OUT TEMP",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder2/CoolingFreshWater/Outlet/Temp/",
    color: "#56ebc1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder3/CoolingFreshWater/Outlet/Temp/",
    name: "NO.3 G/E HT CFW ENG OUT TEMP",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder3/CoolingFreshWater/Outlet/Temp/",
    color: "#911eb4",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/CoolingFreshWater/Outlet/Temp/",
    name: "NO.4 G/E HT CFW ENG OUT TEMP",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/CoolingFreshWater/Outlet/Temp/",
    color: "#e6beff",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder5/CoolingFreshWater/Outlet/Temp/",
    name: "NO.5 G/E HT CFW ENG OUT TEMP",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder5/CoolingFreshWater/Outlet/Temp/",
    color: "#0a84e3",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jrcs_mac/DieselGeneratorSet/Engine1/ExhaustGas/Outlet/Temp/",
    name: "NO.1 G/E EXH GAS OUT TEMP",
    keyName: "/jrcs_mac/DieselGeneratorSet/Engine1/ExhaustGas/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jrcs_mac/DieselGeneratorSet/Engine2/ExhaustGas/Outlet/Temp/",
    name: "NO.2 G/E EXH GAS OUT TEMP",
    keyName: "/jrcs_mac/DieselGeneratorSet/Engine2/ExhaustGas/Outlet/Temp/",
    color: "#f553ec",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key:  "/jrcs_mac/DieselGeneratorSet/Engine3/ExhaustGas/Outlet/Temp/",
    name: "NO.3 G/E EXH GAS OUT TEMP",
    keyName:  "/jrcs_mac/DieselGeneratorSet/Engine3/ExhaustGas/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jrcs_mac/DieselGeneratorSet/Engine4/ExhaustGas/Outlet/Temp/",
    name: "NO.4 G/E EXH GAS OUT TEMP",
    keyName: "/jrcs_mac/DieselGeneratorSet/Engine4/ExhaustGas/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jrcs_mac/DieselGeneratorSet/Engine5/ExhaustGas/Outlet/Temp/",
    name: "NO.5 G/E EXH GAS OUT TEMP",
    keyName: "/jrcs_mac/DieselGeneratorSet/Engine5/ExhaustGas/Outlet/Temp/",
    color: "#fff700",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Engine1/LubOil/Inlet/Press/",
    name: "NO.1 G/E LO ENG IN PRESS",
    keyName: "/jsmea_mac/DieselGeneratorSet/Engine1/LubOil/Inlet/Press/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Engine2/LubOil/Inlet/Press/",
    name: "NO.2 G/E LO ENG IN PRESS",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Engine2/LubOil/Inlet/Press/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Engine3/LubOil/Inlet/Press/",
    name: "NO.3 G/E LO ENG IN PRESS",
    keyName: "/jsmea_mac/DieselGeneratorSet/Engine3/LubOil/Inlet/Press/",
    color: "#a29bfe",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Engine4/LubOil/Inlet/Press/",
    name: "NO.4 G/E LO ENG IN PRESS",
    keyName: "/jsmea_mac/DieselGeneratorSet/Engine4/LubOil/Inlet/Press/",
    color: "#6c5de7",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Engine5/LubOil/Inlet/Press/",
    name: "NO.5 G/E LO ENG IN PRESS",
    keyName: "/jsmea_mac/DieselGeneratorSet/Engine5/LubOil/Inlet/Press/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key: "/jrcs_mac/DieselGeneratorSet/GeneratorBearing1/LubOil//Press/",
    name: "NO.1 D/G BEARING LO PRESS",
    keyName: "/jrcs_mac/DieselGeneratorSet/GeneratorBearing1/LubOil//Press/",
    color: "#57cee1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key:  "/jrcs_mac/DieselGeneratorSet/GeneratorBearing1/LubOil//Press/",
    name: "NO.2 D/G BEARING LO PRESS",
    keyName:  "/jrcs_mac/DieselGeneratorSet/GeneratorBearing2/LubOil//Press/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key:  "/jrcs_mac/DieselGeneratorSet/GeneratorBearing1/LubOil//Press/",
    name: "NO.3 D/G BEARING LO PRESS",
    keyName:  "/jrcs_mac/DieselGeneratorSet/GeneratorBearing3/LubOil//Press/",
    color: "#56ebc1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key:  "/jrcs_mac/DieselGeneratorSet/GeneratorBearing4/LubOil//Press/",
    name: "NO.4 D/G BEARING LO PRESS",
    keyName:  "/jrcs_mac/DieselGeneratorSet/GeneratorBearing4/LubOil//Press/",
    color: "#911eb4",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  {
    key:  "/jrcs_mac/DieselGeneratorSet/GeneratorBearing5/LubOil//Press/",
    name: "NO.5 D/G BEARING LO PRESS",
    keyName:  "/jrcs_mac/DieselGeneratorSet/GeneratorBearing5/LubOil//Press/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.MAINDGMACHINERY,
  },
  // for NO.1 GE cylinder temp
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas1/Outlet/Temp/",
    name: "NO.1 G/E #1 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas1/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas2/Outlet/Temp/",
    name: "NO.1 G/E #2 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas2/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas3/Outlet/Temp/",
    name: "NO.1 G/E #3 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas3/Outlet/Temp/",
    color: "#a29bfe",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas4/Outlet/Temp/",
    name: "NO.1 G/E #4 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas4/Outlet/Temp/",
    color: "#6c5de7",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
    {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas5/Outlet/Temp/",
    name: "NO.1 G/E #5 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas5/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas6/Outlet/Temp/",
    name: "NO.1 G/E #6 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas6/Outlet/Temp/",
    color: "#57cee1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas7/Outlet/Temp/",
    name: "NO.1 G/E #7 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas7/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas8/Outlet/Temp/",
    name: "NO.1 G/E #8 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas8/Outlet/Temp/",
    color: "#56ebc1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas9/Outlet/Temp/",
    name: "NO.1 G/E #9 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas9/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas10/Outlet/Temp/",
    name: "NO.1 G/E #10 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas10/Outlet/Temp/",
    color: "#911eb4",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas11/Outlet/Temp/",
    name: "NO.1 G/E #11 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas11/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas12/Outlet/Temp/",
    name: "NO.1 G/E #12 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas12/Outlet/Temp/",
    color: "#e6beff",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas13/Outlet/Temp/",
    name: "NO.1 G/E #13 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas13/Outlet/Temp/",
    color: "#0a84e3",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas14/Outlet/Temp/",
    name: "NO.1 G/E #14 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas14/Outlet/Temp/",
    color: "#f553ec",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas15/Outlet/Temp/",
    name: "NO.1 G/E #15 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas15/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas16/Outlet/Temp/",
    name: "NO.1 G/E #16 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder1/ExhaustGas16/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP1,
  },
    // for NO.2 GE cylinder temp
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas1/Outlet/Temp/",
    name: "NO.2 G/E #1 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas1/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas2/Outlet/Temp/",
    name: "NO.2 G/E #2 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas2/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas3/Outlet/Temp/",
    name: "NO.2 G/E #3 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas3/Outlet/Temp/",
    color: "#a29bfe",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas4/Outlet/Temp/",
    name: "NO.2 G/E #4 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas4/Outlet/Temp/",
    color: "#6c5de7",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
    {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas5/Outlet/Temp/",
    name: "NO.2 G/E #5 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas5/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas6/Outlet/Temp/",
    name: "NO.2 G/E #6 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas6/Outlet/Temp/",
    color: "#57cee1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas7/Outlet/Temp/",
    name: "NO.2 G/E #7 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas7/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas8/Outlet/Temp/",
    name: "NO.2 G/E #8 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas8/Outlet/Temp/",
    color: "#56ebc1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas9/Outlet/Temp/",
    name: "NO.2 G/E #9 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas9/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas10/Outlet/Temp/",
    name: "NO.2 G/E #10 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas10/Outlet/Temp/",
    color: "#911eb4",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas11/Outlet/Temp/",
    name: "NO.2 G/E #11 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas11/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas12/Outlet/Temp/",
    name: "NO.2 G/E #12 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas12/Outlet/Temp/",
    color: "#e6beff",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas13/Outlet/Temp/",
    name: "NO.2 G/E #13 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas13/Outlet/Temp/",
    color: "#0a84e3",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas14/Outlet/Temp/",
    name: "NO.2 G/E #14 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas14/Outlet/Temp/",
    color: "#f553ec",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas15/Outlet/Temp/",
    name: "NO.2 G/E #15 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas15/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas16/Outlet/Temp/",
    name: "NO.2 G/E #16 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder2/ExhaustGas16/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP2,
  },
    // for NO.3 GE cylinder temp
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas1/Outlet/Temp/",
    name: "NO.3 G/E #1 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas1/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas2/Outlet/Temp/",
    name: "NO.3 G/E #2 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas2/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas3/Outlet/Temp/",
    name: "NO.3 G/E #3 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas3/Outlet/Temp/",
    color: "#a29bfe",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas4/Outlet/Temp/",
    name: "NO.3 G/E #4 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas4/Outlet/Temp/",
    color: "#6c5de7",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
    {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas5/Outlet/Temp/",
    name: "NO.3 G/E #5 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas5/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas6/Outlet/Temp/",
    name: "NO.3 G/E #6 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas6/Outlet/Temp/",
    color: "#57cee1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas7/Outlet/Temp/",
    name: "NO.3 G/E #7 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas7/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas8/Outlet/Temp/",
    name: "NO.3 G/E #8 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas8/Outlet/Temp/",
    color: "#56ebc1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas9/Outlet/Temp/",
    name: "NO.3 G/E #9 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas9/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas10/Outlet/Temp/",
    name: "NO.3 G/E #10 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas10/Outlet/Temp/",
    color: "#911eb4",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas11/Outlet/Temp/",
    name: "NO.3 G/E #11 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas11/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas12/Outlet/Temp/",
    name: "NO.3 G/E #12 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas12/Outlet/Temp/",
    color: "#e6beff",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas13/Outlet/Temp/",
    name: "NO.3 G/E #13 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas13/Outlet/Temp/",
    color: "#0a84e3",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas14/Outlet/Temp/",
    name: "NO.3 G/E #14 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas14/Outlet/Temp/",
    color: "#f553ec",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas15/Outlet/Temp/",
    name: "NO.3 G/E #15 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas15/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas16/Outlet/Temp/",
    name: "NO.3 G/E #16 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder3/ExhaustGas16/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP3,
  },
    // for NO.4 GE cylinder temp
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas1/Outlet/Temp/",
    name: "NO.4 G/E #1 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas1/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas2/Outlet/Temp/",
    name: "NO.4 G/E #2 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas2/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas3/Outlet/Temp/",
    name: "NO.4 G/E #3 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas3/Outlet/Temp/",
    color: "#a29bfe",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas4/Outlet/Temp/",
    name: "NO.4 G/E #4 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas4/Outlet/Temp/",
    color: "#6c5de7",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
    {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas5/Outlet/Temp/",
    name: "NO.4 G/E #5 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas5/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas6/Outlet/Temp/",
    name: "NO.4 G/E #6 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas6/Outlet/Temp/",
    color: "#57cee1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas7/Outlet/Temp/",
    name: "NO.4 G/E #7 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas7/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas8/Outlet/Temp/",
    name: "NO.4 G/E #8 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas8/Outlet/Temp/",
    color: "#56ebc1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas9/Outlet/Temp/",
    name: "NO.4 G/E #9 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas9/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas10/Outlet/Temp/",
    name: "NO.4 G/E #10 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas10/Outlet/Temp/",
    color: "#911eb4",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas11/Outlet/Temp/",
    name: "NO.4 G/E #11 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas11/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas12/Outlet/Temp/",
    name: "NO.4 G/E #12 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas12/Outlet/Temp/",
    color: "#e6beff",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas13/Outlet/Temp/",
    name: "NO.4 G/E #13 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas13/Outlet/Temp/",
    color: "#0a84e3",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas14/Outlet/Temp/",
    name: "NO.4 G/E #14 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas14/Outlet/Temp/",
    color: "#f553ec",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas15/Outlet/Temp/",
    name: "NO.4 G/E #15 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas15/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
  {
    key: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas16/Outlet/Temp/",
    name: "NO.4 G/E #16 EXF GAS CYL OUT T",
    keyName: "/jsmea_mac/DieselGeneratorSet/Cylinder4/ExhaustGas16/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP4,
  },
    // for NO.5 GE cylinder temp
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas1/Outlet/Temp/",
    name: "NO.5 G/E #1 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas1/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas2/Outlet/Temp/",
    name: "NO.5 G/E #2 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas2/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas3/Outlet/Temp/",
    name: "NO.5 G/E #3 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas3/Outlet/Temp/",
    color: "#a29bfe",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas4/Outlet/Temp/",
    name: "NO.5 G/E #4 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas4/Outlet/Temp/",
    color: "#6c5de7",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
    {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas5/Outlet/Temp/",
    name: "NO.5 G/E #5 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas5/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas6/Outlet/Temp/",
    name: "NO.5 G/E #6 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas6/Outlet/Temp/",
    color: "#57cee1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas7/Outlet/Temp/",
    name: "NO.5 G/E #7 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas7/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas8/Outlet/Temp/",
    name: "NO.5 G/E #8 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas8/Outlet/Temp/",
    color: "#56ebc1",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas9/Outlet/Temp/",
    name: "NO.5 G/E #9 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas9/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas10/Outlet/Temp/",
    name: "NO.5 G/E #10 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas10/Outlet/Temp/",
    color: "#911eb4",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas11/Outlet/Temp/",
    name: "NO.5 G/E #11 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas11/Outlet/Temp/",
    color: "#4fa8de",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas12/Outlet/Temp/",
    name: "NO.5 G/E #12 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas12/Outlet/Temp/",
    color: "#e6beff",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas13/Outlet/Temp/",
    name: "NO.5 G/E #13 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas13/Outlet/Temp/",
    color: "#0a84e3",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas14/Outlet/Temp/",
    name: "NO.5 G/E #14 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas14/Outlet/Temp/",
    color: "#f553ec",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas15/Outlet/Temp/",
    name: "NO.5 G/E #15 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas15/Outlet/Temp/",
    color: "#e74293",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
  {
    key:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas16/Outlet/Temp/",
    name: "NO.5 G/E #16 EXF GAS CYL OUT T",
    keyName:  "/jsmea_mac/DieselGeneratorSet/Cylinder5/ExhaustGas16/Outlet/Temp/",
    color: "#fc78a8",
    enableVisibilityIcon: "hidden",
    enable: true,
    chartType: ADDITIONAL_ELECTRIC_TREND_TYPE.GECYLTEMP5,
  },
];

